import { DeletePipelineDialog } from '../components/dialogs/DeletePipelineDialog'
import SchedulePipeline from '../components/dialogs/SchedulePipeline'
import SourceConfiguration from '../components/source/sheets/SourceConfiguration'
import SourcePicker from '../components/source/sheets/SourcePicker'
import DqReportModal from '../components/dialogs/dq-report-modal/DqReportmodal'
import DownloadOutputModal from '../components/dialogs/download-output-modal/DownloadOutputModal'
import ExplorerDialog from '../components/source/dialogs/explorer-dialog/ExplorerDialog'
import DataProfilingConfirmation from '../components/source/dialogs/DataProfilingConfirmation'
import DataProfilingDialog from '../components/source/dialogs/data-profiling/DataProfilingDialog'
import DestinationPicker from '../components/destination/sheets/DestinationPicker'
import DestinationConfiguration from '../components/destination/sheets/DestinationConfiguration'
import LoadType from '../components/destination/dialogs/load-type/LoadType'
import OutputPreview from '../components/destination/dialogs/output-preview/OutputPreview'
import ColumnMapping from '../components/destination/dialogs/column-mapping/ColumnMapping'
import TransformationSheet from '../components/sheets/transformation-sheet/TransformationSheet'
import JoinIntegrationSheet from '../components/sheets/join-integration-sheet/JoinIntegrationSheet'
import UnionIntegrationSheet from '../components/sheets/union-integration-sheet/UnionIntegrationSheet'
import RunHistoryModal from '../components/dialogs/run-history-modal/RunHistoryModal'
import LogsModal from '../components/dialogs/logs-modal/LogsModal'
import SourceRegisterationDialog from '../components/source/dialogs/source-registeration-modal/SourceRegisterationDialog'
import DestinationRegisterationDialog from '../components/destination/dialogs/destination-registeration-modal/DestinationRegisterationDialog'
import RegisteredSourcesTableList from '../components/source/dialogs/source-registered-tables-dialog/RegisteredSourcesTableList/RegisteredSourcesTableList'
import AddNewTable from '../components/source/dialogs/source-registered-tables-dialog/AddNewTable/AddNewTable'
import RegisteredDestinationsDetails from '../components/destination/dialogs/destination-registered-dialogs/registered-destination-details/RegisteredDestinationsDetails'
import RegisteredDestinationsTableList from '../components/destination/dialogs/destination-registered-dialogs/registered-destination-table-list/RegisteredDestinationsTableList'
import { EditPipelineModal } from '../components/dialogs/edit-pipeline-modal'
import TransformationDatasourcePickerDialog from '../components/dialogs/transformation-datasource-picker-dialog/TransformationDatasourcePickerDialog'

const OverlayProvider = () => {
  return (
    <>
      <SchedulePipeline />
      <SourcePicker />
      <SourceRegisterationDialog />
      <RegisteredSourcesTableList />
      <AddNewTable />
      <SourceConfiguration />
      <EditPipelineModal />
      <DeletePipelineDialog />
      <DqReportModal />
      <DownloadOutputModal />
      <ExplorerDialog />
      <DataProfilingConfirmation />
      <DataProfilingDialog />
      <DestinationPicker />
      <DestinationRegisterationDialog />
      <RegisteredDestinationsDetails />
      <RegisteredDestinationsTableList />
      <DestinationConfiguration />
      <LoadType />
      <OutputPreview />
      <ColumnMapping />
      <TransformationSheet />
      <JoinIntegrationSheet />
      <UnionIntegrationSheet />
      <TransformationDatasourcePickerDialog />
      <RunHistoryModal />
      <LogsModal />
    </>
  )
}

export default OverlayProvider
